import { getProjectPictureUrl } from '../utils/cloudinary';

export const stringToProjectImage = (picture: string): string => {
    // Returns optimized Cloudinary URL for project pictures
    // The picture parameter should match the filename (can include extension, will be stripped)
    if (!picture) return "";
    
    // Remove extension if present to get the Cloudinary public ID
    const imageName = picture.replace(/\.(jpg|jpeg|png|webp|avif|gif)$/i, '');
    return getProjectPictureUrl(imageName);
};
